var _rect, _circle, _circle2, _path, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacePink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFE7EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 36,
    r: 15,
    fill: "#FF6187"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 35.9994,
    r: 15,
    transform: "rotate(9.8144 36 35.9994)",
    stroke: "#003B6F",
    strokeWidth: 2.25,
    strokeLinecap: "square"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4651 44.8682C38.3028 45.5339 42.2759 43.6364 44.0788 39.9633L45.9705 39.9615",
    stroke: "#003B6F",
    strokeWidth: 2.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 33.375,
    r: 1.875,
    fill: "#003764"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 33.375,
    r: 1.875,
    fill: "#003764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacePink);
export default __webpack_public_path__ + "static/media/face-pink.c0aceb68462bf76c52e59f6b4b5702dc.svg";
export { ForwardRef as ReactComponent };